import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { dailyContentApi } from "@/lib/api";
import { queryKeys } from "./keys";

export function useCurrentDailyVerse() {
  return useQuery({
    queryKey: queryKeys.daily.verse,
    queryFn: dailyContentApi.getCurrentDailyVerse,
  });
}

export function useCurrentDailyReflection() {
  return useQuery({
    queryKey: queryKeys.daily.reflection,
    queryFn: dailyContentApi.getCurrentDailyReflection,
  });
}

function useInvalidateReflection() {
  const queryClient = useQueryClient();
  return () => {
    void queryClient.invalidateQueries({ queryKey: queryKeys.daily.reflection });
    void queryClient.invalidateQueries({ queryKey: queryKeys.daily.content });
  };
}

export function useUpdateDailyReflection() {
  const invalidate = useInvalidateReflection();
  return useMutation({
    mutationFn: (body: string) => dailyContentApi.updateDailyReflection(body),
    onSuccess: invalidate,
  });
}

export function useRegenerateDailyReflection() {
  const invalidate = useInvalidateReflection();
  return useMutation({
    mutationFn: dailyContentApi.regenerateDailyReflection,
    onSuccess: invalidate,
  });
}

export function useRestoreAutomaticDailyReflection() {
  const invalidate = useInvalidateReflection();
  return useMutation({
    mutationFn: dailyContentApi.restoreAutomaticDailyReflection,
    onSuccess: invalidate,
  });
}
